import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { CustomizationService } from '../../../admin360/customization/customization.service';
import { AddEditDesignPageDescriptionComponent } from '../../../admin360/customization/design-pages/add-edit-design-page-description/add-edit-design-page-description.component';
import { CustomDesignPage } from '../../../admin360/customization/models/custom-design-page.model';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { EFormConfiguration, enmEFormViewModes } from '../../../shared-components/e-forms/e-form-config.model';
import { EFormDesignerComponent } from '../../../shared-components/e-forms/e-form-designer/e-form-designer.component';
import { EFormDesignerService } from '../../../shared-components/e-forms/e-form-designer/e-form-designer.service';
import { EFormViewerModalComponent } from '../../../shared-components/e-forms/e-form-viewer/e-form-viewer-modal/e-form-viewer-modal.component';
import { EForm } from '../../../shared-components/e-forms/e-form.model';
import { EFormService } from '../../../shared-components/e-forms/e-form.service';
import { EFormDataObject } from '../../../shared-components/e-forms/e-formDataObject.model';
import { SecurityService } from '../../../shared-components/security/security.service';
import { LoginService } from '../../login/login.service';
import { CustomizationFrameworkService } from '../customization-framework.service';
import * as _ from 'lodash';
import { detailExpand } from '../../../shared-components/angular-material/mat-animations';
import { orderBy } from 'lodash';

@Component({
  selector: 'view-design-pages',
  templateUrl: './view-design-pages.component.html',
  styleUrls: ['./view-design-pages.component.css'],
  animations: [detailExpand]
})
export class ViewDesignPagesComponent implements OnInit {

  allDesignPages: CustomDesignPage[];
  @Input() designPageId: number;
  @Input() allowViewEdit: boolean;

  @Output() designPageUpdated: EventEmitter<boolean> = new EventEmitter<boolean>();


  private subscriptions: Subscription[] = [];
  columnsToDisplay: string[] = ['More', 'ModuleName', 'ObjectName', 'Name', 'Status', 'Actions'];
  @ViewChild(MatSort, { static: false }) set sort(value: MatSort) {
    this.dataSource.sort = value;
  }
  dataSource: TylerMatTableDataSource = new TylerMatTableDataSource();
  config: EFormConfiguration = new EFormConfiguration();
  userCanEdit = false;
  componentRef: any;
  // errorList: ErrorList[] = [];
  rowsExpanded = false;
  devMode = false;

  constructor(
    private customizationService: CustomizationService,
    private customizationFrameworkService: CustomizationFrameworkService,
    private eFormService: EFormService,
    private eFormDesignerService: EFormDesignerService,
    private dialog: MatDialog,
    private securityService: SecurityService,
    private loginService: LoginService
  ) {
    this.config.ParentHandlesSave = true;
    this.config.PageFlag = true;
    this.config.CustomFieldsFlag = true;

    this.userCanEdit = this.securityService.IsAllPermissionCodeAssigned('SUI_MDP');
    this.devMode = this.loginService.LoginSettings.CustomizationDevMode ? true : false;
  }

  ngOnInit() {
    this.getDesignPages();
  }

  getDesignPages() {
    this.subscriptions.push(this.customizationService.getDesignPageByIDs(false, this.designPageId ? [this.designPageId] : [], true).subscribe(pages => {
      pages.forEach(page => {
          page.HasDetailRows = pages.filter(p => !p.BasePage && p.DesignPageID == page.DesignPageID).length > 0;
      });
      if (this.designPageId) {
        this.allDesignPages = orderBy(pages, ['BasePage', 'Description'], ['desc', 'asc']);
        const bp = pages.find(o => o.BasePage);
        if (bp) {
          bp.Description = 'System Page';
        }
      }
      else {
        this.allDesignPages = pages;
      }
      this.dataSource.data = pages.filter(p => p.BasePage);
    }));
  }

  addClick() {

  }

  editClick(page: CustomDesignPage) {
    this.customizationFrameworkService.getCustomDataFieldsByObjectID(page.ObjectID).subscribe(results => {
      if (results) {
        this.eFormDesignerService.availableCSTFields = results;
      }
      else {
        this.eFormDesignerService.availableCSTFields = [];
      }
      this.openDesigner(page);
    });
  }

  viewClick(page: CustomDesignPage) {
    const eForm: EForm = new EForm;

    eForm.FormData = page.FormData;

    this.eFormService.selectedForm = eForm;
    try {
      this.eFormService.selectedFormData = JSON.parse(eForm.FormData);
    } catch (err) {
      this.eFormService.selectedFormData = new EFormDataObject();
    }
    const vConfig = new EFormConfiguration();
    vConfig.ViewMode = enmEFormViewModes.Page;
    vConfig.ShowSubmittedBy = false;
    vConfig.DisableSubmission = true;
    vConfig.ReadOnly = false;
    vConfig.UseInstance = false;
    vConfig.Title = page.Name;
    vConfig.HideLanguageDropDown = true;
    const viewFormDialog = this.dialog.open(EFormViewerModalComponent, {
      disableClose: true,
      height: '100vh',
      width: '100vw',
      data: {
        config: vConfig
      }
    });
  }

  openDesigner(page: CustomDesignPage = new CustomDesignPage) {
    this.config.Title = page.Name;
    this.config.CSTFieldsManageOwnData = this.loginService.LoginSettings.CustomizationDevMode ? false : true;
    this.eFormService.selectedDesignPage = page;
    this.config.ViewMode = enmEFormViewModes.Page;
    this.config.AllowPages = false;
    this.config.AllowTabs = false;
    this.config.AllowAttachmentControls = false;
    this.config.AllowColumnWidth = true;
    this.config.AllowShowTodayButton = true;
    this.customizationFrameworkService.reconcileChangesToDesignPage(page).pipe(take(1)).subscribe(formData => {
      page.FormData = JSON.stringify(formData);
      page.Version = page.BaseVersion;
      this.eFormService.selectedFormData = formData;
      const dialogRef = this.dialog.open(EFormDesignerComponent, {
        height: '100vh',
        maxHeight: '100vh',
        width: '100vw',
        maxWidth: '100vw',
        disableClose: true,
        autoFocus: false,
        data: { config: this.config, basePage: page.BasePage }
      });
      this.subscriptions.push(dialogRef.afterClosed().subscribe(pageSaved => {
        this.getDesignPages();
      }));
      this.subscriptions.push(dialogRef.componentInstance.saveEvent.subscribe(pageSaved => {
        if (pageSaved == 'save' || pageSaved == 'saveBasePage') {
          this.customizationService.saveDesignPageTemplate(page).subscribe(result => {
            page = result;
            this.eFormService.selectedDesignPage = result;
            this.designPageUpdated.emit(true);
            this.getDesignPages();
          });
        }
      }));
    });
  }

  addUserPageClick(basePage: CustomDesignPage) {
    const newUserPage: CustomDesignPage = new CustomDesignPage;
    newUserPage.ID = 0;
    newUserPage.Active = false;
    newUserPage.BasePage = false;
    newUserPage.FormData = _.clone(basePage.FormData);
    newUserPage.DesignPageID = basePage.DesignPageID;
    newUserPage.Version = basePage.Version;

    const editDescriptionDialog = this.dialog.open(AddEditDesignPageDescriptionComponent, {
      disableClose: true,
      data: {
        page: newUserPage,
        newTemplate: true
      }
    });
    editDescriptionDialog.afterClosed().subscribe((page: CustomDesignPage) => {
      if (page) {
        this.customizationFrameworkService.getCustomDataFieldsByObjectID(basePage.ObjectID).subscribe(results => {
          if (results) {
            this.eFormDesignerService.availableCSTFields = results;
          }
          else {
            this.eFormDesignerService.availableCSTFields = [];
          }
          this.openDesigner(newUserPage);
        });
      }
    });
  }

  addVersion() {
    const page = this.allDesignPages.find(o => o.DesignPageID == this.designPageId && o.BasePage);
    if (page) {
      this.addUserPageClick(page);
    }
  }

  expandCollapseAll() {
    let allCollapsed = true;
    this.dataSource.data.forEach(designPage => {
      if (designPage.detailRow) {
        allCollapsed = false;
      }
    });
    if (allCollapsed) {
      this.dataSource.expandAll(true);
      this.rowsExpanded = true;
    }
    else {
      this.dataSource.expandAll(false);
      this.rowsExpanded = false;
    }
  }

  revertClick(basePage: CustomDesignPage) {
    this.customizationService.toggleActiveDesignPageTemplate(basePage.ID).subscribe(() => {
      this.getDesignPages();
      this.designPageUpdated.emit(true);
    });
  }

  designPageUpdatedHandler() {
    this.designPageUpdated.emit(true);
  }

}
